(function () {
    'use strict';

    function LoginCtrl(authService, $state, toastr) {
        var vm = this;

        vm.validationErrors = [];
        vm.busy = false;
        vm.loginData = {
            userName: '',
            password: ''
        };
        
        vm.login = function (form) {
            if (vm.busy) return;

            if (form.$valid) {
                vm.busy = true;
                vm.validationErrors = [];
                authService.login(vm.loginData).then(
                    function () {
                        $state.go('home');
                    },
                    function (err) {
                        toastr.error('Unable to log in.', 'Error');
                        if (err && err.error_description) {
                            vm.validationErrors.push(err.error_description);
                        }
                        vm.busy = false;
                    }
                );
            } else {
                vm.busy = false;
            }
        };
    };

    angular
        .module('app')
        .controller('LoginCtrl', [
            'authService',
            '$state',
            'toastr', LoginCtrl]);

})();